import React from 'react';

export default function TextCursorIcon({as = React.Fragment, Tag = as, ...props}) {
  return (
    <Tag {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-text-cursor"><circle cx="12" cy="12" r="10" className="primary"/><path className="secondary" d="M12 7.35A3.99 3.99 0 0 1 15 6a1 1 0 0 1 0 2 2 2 0 0 0-2 2v4c0 1.1.9 2 2 2a1 1 0 0 1 0 2c-1.2 0-2.27-.52-3-1.35A3.99 3.99 0 0 1 9 18a1 1 0 0 1 0-2 2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2 1 1 0 1 1 0-2c1.2 0 2.27.52 3 1.35z"/></svg>
    </Tag>
  )
};
